import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5888 0.200012H2.81101C2.30416 0.200012 1.81806 0.401361 1.45965 0.759764C1.10125 1.11817 0.899902 1.60427 0.899902 2.11112V16.8889C0.899902 17.3958 1.10125 17.8819 1.45965 18.2403C1.81806 18.5987 2.30416 18.8 2.81101 18.8H17.5888C18.0956 18.8 18.5817 18.5987 18.9401 18.2403C19.2986 17.8819 19.4999 17.3958 19.4999 16.8889V2.11112C19.4999 1.60427 19.2986 1.11817 18.9401 0.759764C18.5817 0.401361 18.0956 0.200012 17.5888 0.200012ZM7.85552 3.36664L7.51775 6.53331H5.09961V8.24442H7.33727L7.08616 10.7555H5.09961V12.4666H6.90597L6.56819 15.6333H8.27703L8.61481 12.4666H11.1282L10.7904 15.6333H12.4993L12.837 12.4666H15.2552V10.7555H13.0175L13.2686 8.24442H15.2552V6.53331H13.4488L13.7866 3.36664H12.0777L11.74 6.53331H9.22659L9.56436 3.36664H7.85552ZM9.04639 8.24442H11.5595L11.3084 10.7555H8.79528L9.04639 8.24442Z"
      fill="#222A5C"
    />
  </svg>,
  "Short Code"
);
